import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";
import { downloadExcel } from "react-export-table-to-excel";
import MultiSelect from "./multiSelect.js";

const MySwal = withReactContent(Swal2);

const Doubles = (props) => {
  const [loading, setLoading] = useState(true);
  const [leads, setLeads] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [leadsOri, setLeadsOri] = useState([]);
  const [sources, setSources] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [filterText, setFilterText] = useState([]);
  const [filterSource, setFilterSource] = useState("");
  const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
  const [isHoveringSource, setIsHoveringSource] = useState(false);
  const [filterCompany, setFilterCompany] = useState("");
  const [selectedOptionsCompany, setSelectedOptionsCompany] = useState([]);
  const [isHoveringCompany, setIsHoveringCompany] = useState(false);
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");
  const [filterDate, setFilterDate] = useState(false);
  const [sort, setSort] = useState("dateDesc");

  const fetchLeadsDub = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getLeadsDubData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data);
        setLeadsOri(data);
        fetchSources();
      })
      .catch((error) => {});
  };

  const fetchSources = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data);
        fetchCompanies();
      })
      .catch((error) => {});
  };

  const fetchCompanies = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getCompanies", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setCompanies(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchLeadsDub();
  };

  useEffect(() => {
    getData();
  }, []);

  const leadsData = (
    <>
      <p style={{ textAlign: "left", margin: "0", fontSize: ".8vw" }}>
        Liczba kontaktów: {leads.length}
      </p>
      <table style={{ marginTop: "0vh" }} className="clients_table">
        <tr key={0}>
          <th>id</th>
          <th>nazwa</th>
          <th>numer Telefonu</th>
          <th>adres e-mail</th>
          <th>źródło</th>
          <th>data pozyskania</th>
          <th>uwagi - źródło</th>
          <th>dział</th>
          <th>przyczyna</th>
        </tr>
        {leads.map((el, index) => (
          <>
            <tr style={{ height: "15vh" }} key={el.id}>
              <td>{el.id}</td>
              <td>{el.name}</td>
              <td>{el.phone}</td>
              <td>{el.mail}</td>
              <td>{el.source}</td>
              <td>{el.date}</td>
              <td
                style={{ width: "20%", lineBreak: "anywhere", paddiing: "5px" }}
              >
                {el.sourceNote}
              </td>
              <td>{el.company}</td>
              <td>{el.doubleReason}</td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const createExcelDS = () => {
    var tab = [];
    leads.map((el) => {
      tab.push([
        el.id,
        el.name,
        el.phone,
        el.mail,
        el.source,
        el.date,
        el.sourceNote,
        el.company,
        el.doubleReason,
      ]);
    });
    return tab;
  };

  const exportToExcel = (e) => {
    var header = [
      "ID",
      "Imię i nazwisko",
      "Numer telefonu",
      "Adres e-mail",
      "Źródło",
      "Data pozyskania",
      "Uwagi - źródło",
      "Dział",
      "Przyczyna duplikatu",
    ];
    downloadExcel({
      fileName: "leads_duplicates_report_" + new Date(),
      sheet: "data",
      tablePayload: {
        header,
        body: createExcelDS(),
      },
    });
  };

  const clearFilters = (e) => {
    setFilterText("");
    setFilterSource([]);
    setSelectedOptionsSource([]);
    setFilterCompany([]);
    setSelectedOptionsCompany([]);
    setFilterDateFrom("");
    setFilterDateTo("");
    setFilterDate(false);
    setSort("dateDesc");
    setLeads(leadsOri);
  };

  const getSourceOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });

    sources.map((el) => {
      var opt = { label: el.name, value: el.name };
      arr.push(opt);
    });

    return arr;
  };

  const getCompanyOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });

    companies.map((el) => {
      var opt = { label: el.name, value: el.name };
      arr.push(opt);
    });

    return arr;
  };

  const checkOption = (arr, value) => {
    if (arr.filter((el) => el === value).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const checkOptionNum = (arr, value) => {
    if (arr.filter((el) => +el === +value).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleFilterChange = (value, mode, data) => {
    var arr = data;

    var fText = mode === "filterText" ? value : filterText;
    if (filterText.length > 0 || mode === "filterText") {
      arr = arr.filter(
        (el) =>
          el.name.includes(fText) ||
          el.phone.includes(fText) ||
          el.mail.includes(fText)
      );
    }

    var fSource = mode === "filterSource" ? value : filterSource;
    if (filterSource.length > 0 || mode === "filterSource") {
      arr = arr.filter((el) => checkOption(fSource, el.source));
    }

    var fCompany = mode === "filterCompany" ? value : filterCompany;
    if (filterCompany.length > 0 || mode === "filterCompany") {
      arr = arr.filter((el) => checkOption(fCompany, el.company));
    }

    var fDate = mode === "filterDate" ? value : filterDate;
    if (fDate) {
      arr = arr.filter(
        (el) =>
          new Date(el.date).getFullYear() +
            "-" +
            new Date(el.date).getMonth() +
            "-" +
            new Date(el.date).getDate() >=
            new Date(filterDateFrom).getFullYear() +
              "-" +
              new Date(filterDateFrom).getMonth() +
              "-" +
              new Date(filterDateFrom).getDate() &&
          new Date(el.date).getFullYear() +
            "-" +
            new Date(el.date).getMonth() +
            "-" +
            new Date(el.date).getDate() <=
            new Date(filterDateTo).getFullYear() +
              "-" +
              new Date(filterDateTo).getMonth() +
              "-" +
              new Date(filterDateTo).getDate()
      );
    }

    setLeads(arr);
    handleSortChange(sort, arr);
  };

  const handleChangeFilterText = (e) => {
    setFilterText(e.target.value);
    handleFilterChange(e.target.value, "filterText", leadsOri);
  };

  const handleChangeFilterSource = (e) => {
    setFilterSource(e);
    handleFilterChange(e, "filterSource", leadsOri);
  };

  const handleChangeFilterCompany = (e) => {
    setFilterCompany(e);
    handleFilterChange(e, "filterCompany", leadsOri);
  };

  const closeAllHovering = (e) => {
    if (e.target.id !== "source" && e.target.id !== "company") {
      setIsHoveringSource(false);
      setIsHoveringCompany(false);
    }
  };

  const handleChangeFilterDateFrom = (e) => {
    if (new Date(e.target.value) > new Date(filterDateTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setFilterDateFrom(e.target.value);
  };

  const handleChangeFilterDateTo = (e) => {
    if (new Date(e.target.value) < new Date(filterDateFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data do",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    setFilterDateTo(e.target.value);
  };

  const handleChangeFilterDate = (e) => {
    if (filterDateFrom && filterDateTo) {
      setFilterDate(true);
      handleFilterChange(true, "filterDate", leadsOri);
    }
  };

  const handleSortChange = (mode, data) => {
    if (mode === "") {
      return;
    }

    if (mode === "dateAsc") {
      setLeads(
        data.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        })
      );
    } else if (mode === "dateDesc") {
      setLeads(
        data.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        })
      );
    }
  };

  const handleSortDataChange = (e) => {
    setSort(e.target.value);
    handleSortChange(e.target.value, leads);
  };

  return (
    <>
      <div onClick={closeAllHovering}>
        {loading ? (
          <Loading />
        ) : (
          <>
            <div
              style={{
                paddingBottom: "3vh",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                  gap: "1vw",
                  alignItems: "self-end",
                  position: "sticky",
                  flexWrap: "wrap",
                  top: "0",
                  zIndex: "1",
                  padding: "5px 5px",
                  backgroundColor: "white",
                  paddingLeft: "1vw",
                  width: "100%",
                  paddingBottom: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "self-end",
                    justifyContent: "left",
                    gap: "1vw",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                      width: "180px",
                      height: "3vh",
                    }}
                    onClick={getData}
                  >
                    ODŚWIEŻ
                  </button>

                  {props.user.role === "admin" ? (
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        margin: "0",
                        backgroundColor: "blue",
                        borderColor: "blue",
                        width: "180px",
                        height: "3vh",
                      }}
                      onClick={exportToExcel}
                    >
                      EKSPORT DO EXCEL
                    </button>
                  ) : (
                    ""
                  )}
                  <div style={{ width: "180px", textAlign: "left" }}>
                    <p
                      style={{
                        margin: "0",
                        marginBottom: "2px",
                        fontWeight: "600",
                        fontSize: ".6vw",
                        paddingLeft: "2px",
                      }}
                    >
                      nazwa, tel., mail
                    </p>
                    <input
                      type="text"
                      style={{
                        width: "100%",
                        padding: "0px 10px",
                        boxSizing: "border-box",
                        height: "3vh",
                      }}
                      value={filterText}
                      onChange={handleChangeFilterText}
                    />
                  </div>
                </div>

                <div
                  style={
                    showFilters
                      ? {
                          width: "100%",
                          display: "block",
                        }
                      : {
                          display: "none",
                        }
                  }
                >
                  <p style={{ textAlign: "left", fontWeight: "600" }}>FILTRY</p>

                  <div
                    style={{
                      display: "flex",
                      gap: "5px 20px",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "23%", textAlign: "left" }}>
                      <p
                        style={{
                          margin: "0",
                          marginBottom: "10px",
                          fontWeight: "600",
                          fontSize: ".6vw",
                          paddingLeft: "2px",
                        }}
                      >
                        źródło
                      </p>
                      <MultiSelect
                        options={getSourceOptions()}
                        value={filterSource}
                        onChange={handleChangeFilterSource}
                        selectedOptions={selectedOptionsSource}
                        setSelectedOptions={setSelectedOptionsSource}
                        isHovering={isHoveringSource}
                        setIsHovering={setIsHoveringSource}
                        id={"source"}
                        closeAllHovering={closeAllHovering}
                      />
                    </div>
                    {props.user.role === "admin" ? (
                      <>
                        <div style={{ width: "23%", textAlign: "left" }}>
                          <p
                            style={{
                              margin: "0",
                              marginBottom: "10px",
                              fontWeight: "600",
                              fontSize: ".6vw",
                              paddingLeft: "2px",
                            }}
                          >
                            dział
                          </p>
                          <MultiSelect
                            options={getCompanyOptions()}
                            value={filterCompany}
                            onChange={handleChangeFilterCompany}
                            selectedOptions={selectedOptionsCompany}
                            setSelectedOptions={setSelectedOptionsCompany}
                            isHovering={isHoveringCompany}
                            setIsHovering={setIsHoveringCompany}
                            id={"company"}
                            closeAllHovering={closeAllHovering}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div style={{ width: "23%", textAlign: "left" }}></div>
                    <div style={{ width: "23%", textAlign: "left" }}></div>
                    {props.user.role === "user" ? (
                      <>
                        <div style={{ width: "100%" }}></div>
                      </>
                    ) : (
                      ""
                    )}
                    <div style={{ display: "block" }}>
                      <div
                        style={{
                          marginBottom: "1vh",
                          width: "100%",
                          textAlign: "left",
                        }}
                      >
                        <label
                          style={{
                            fontSize: ".6vw",
                            fontWeight: "600",
                            paddingLeft: "5px",
                          }}
                        >
                          data pozyskania
                        </label>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            width: "100%",
                          }}
                          className="inputBox"
                        >
                          <div style={{ width: "45%" }}>
                            <label
                              style={{
                                fontSize: ".6vw",
                                paddingLeft: "5px",
                              }}
                            >
                              od
                            </label>
                            <input
                              style={{ height: "3vh", width: "100%" }}
                              type="date"
                              id="name"
                              name="name"
                              value={filterDateFrom}
                              onChange={handleChangeFilterDateFrom}
                            />
                          </div>
                          <div style={{ width: "45%" }}>
                            <label
                              style={{
                                fontSize: ".6vw",
                                paddingLeft: "5px",
                              }}
                            >
                              do
                            </label>
                            <input
                              style={{ height: "3vh", width: "100%" }}
                              type="date"
                              id="name"
                              name="name"
                              value={filterDateTo}
                              onChange={handleChangeFilterDateTo}
                            />
                          </div>
                        </div>
                        <div style={{ marginTop: "10px", textAlign: "left" }}>
                          <button
                            style={{
                              backgroundColor: "navy",
                              border: "none",
                              color: "white",
                              textTransform: "uppercase",
                              fontWeight: "600",
                              borderRadius: "5px",
                            }}
                            id="clientsFilterButton"
                            className="paymentMenuButton"
                            onClick={handleChangeFilterDate}
                          >
                            Zastosuj filtr daty
                          </button>
                        </div>
                      </div>
                    </div>
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        margin: "0",
                        backgroundColor: "green",
                        borderColor: "green",
                        width: "140px",
                        fontSize: ".6vw",
                        height: "3vh",
                      }}
                      onClick={clearFilters}
                    >
                      WYCZYŚĆ FILTRY
                    </button>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <select
                      style={{ height: "3vh", width: "25%" }}
                      type="date"
                      id="name"
                      name="name"
                      value={sort}
                      onChange={handleSortDataChange}
                    >
                      {sort === "" ? (
                        <option key={2}>Wybierz sortowanie...</option>
                      ) : (
                        ""
                      )}
                      <option key={0} value="dateAsc">
                        Data pozyskania - od najstarszej
                      </option>
                      <option key={1} value="dateDesc">
                        Data pozyskania - od najmłodszej
                      </option>
                    </select>
                  </div>
                </div>
                <div style={{ marginTop: "-3vh" }}>
                  <button
                    className="loginButtonLogin"
                    onClick={() => {
                      setShowFilters(!showFilters);
                    }}
                    style={{
                      margin: "0",
                      backgroundColor: "orange",
                      borderColor: "orange",
                      width: "100px",
                      fontSize: ".6vw",
                      height: "2vh",
                      color: "white",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {showFilters ? "zwiń filtry" : "rozwiń filtry"}
                  </button>
                </div>
              </div>
              <div style={{ paddingLeft: "1vw" }}>{leadsData}</div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Doubles;
